"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Session_1 = require("../RtcSession/Session");
class LinkStatistics {
    constructor(attendee) {
        this._curPercentLost = 0;
        this._linkLastSeqenceNumber = 0;
        this.Attendee = attendee;
    }
    get CurPercentLost() { return this._curPercentLost; }
    set CurPercentLost(value) { this._curPercentLost = value; }
    get LinkLastSeqenceNumber() { return this._linkLastSeqenceNumber; }
    set LinkLastSeqenceNumber(value) { this._linkLastSeqenceNumber = value; }
}
exports.LinkStatistics = LinkStatistics;
class ConferenceResource {
    constructor(crPara) {
        this._linkStatsDic = new Map();
        // link establishment timeout, default is 30,000ms
        this.ConferenceTimeout = 30000;
        // how many milliseconds must elapse with no receive activity before a stream is considered dead. Defaults to 15000.
        this.DeadStreamTimeout = 15000;
        this.PACKET_SEQUENCE_INIT_NUMBER = -1;
        this._lastSeqenceNumber = this.PACKET_SEQUENCE_INIT_NUMBER;
        this.AttachedSessionId = crPara.AttachedSessionId;
        this.FromSessionTicket = crPara.FromSessionTicket;
        //this.DtlsCertificate = crPara.DtlsCertificate;
        this.RelayUsername = crPara.RelayUsername;
        this.RelayPassword = crPara.RelayPassword;
        this.ConferenceTimeout = crPara.ConferenceTimeout || this.ConferenceTimeout;
        this.DeadStreamTimeout = crPara.DeadStreamTimeout || this.DeadStreamTimeout;
        this.ConferenceEventCallback = crPara.ConferenceEventCallback;
        this.OnConferenceLinkInit = crPara.OnConferenceLinkInit;
        this.OnConferenceLinkUp = crPara.OnConferenceLinkUp;
        this.OnConferenceLinkDown = crPara.OnConferenceLinkDown;
        this.OnConferenceLinkReceiveRTCP = crPara.OnConferenceLinkReceiveRTCP;
        this.OnConferenceLinkReceiveRTP = crPara.OnConferenceLinkReceiveRTP;
        this.OnConferenceLinkReceiveSCTP = crPara.OnConferenceLinkReceiveSCTP;
        this.OnConferenceLinkSendRTCP = crPara.OnConferenceLinkSendRTCP;
        this.OnConferenceLinkSendRTP = crPara.OnConferenceLinkSendRTP;
        this.OnVideoStreamLinkInit = crPara.OnVideoStreamLinkInit;
        this.OnVideoStreamLinkUp = crPara.OnVideoStreamLinkUp;
        this.OnVideoStreamLinkDown = crPara.OnVideoStreamLinkDown;
        this.OnVideoStreamLinkReceiveRTCP = crPara.OnVideoStreamLinkReceiveRTCP;
        this.OnVideoStreamLinkReceiveRTP = crPara.OnVideoStreamLinkReceiveRTP;
        this.OnAudioStreamLinkInit = crPara.OnAudioStreamLinkInit;
        this.OnAudioStreamLinkUp = crPara.OnAudioStreamLinkUp;
        this.OnAudioStreamLinkDown = crPara.OnAudioStreamLinkDown;
        this.OnAudioStreamLinkReceiveRTCP = crPara.OnAudioStreamLinkReceiveRTCP;
        this.OnAudioStreamLinkReceiveRTP = crPara.OnAudioStreamLinkReceiveRTP;
    }
    get Conference() { return this._conference; } //fm.icelink.conference
    get AudioStream() { return this._audioStream; } //fm.icelink.webrtc.audioStream
    get VideoStream() { return this._videoStream; } //fm.icelink.webrtc.videoStream
    get LastSeqenceNumber() { return this._lastSeqenceNumber; }
    set LastSeqenceNumber(value) { this._lastSeqenceNumber = value; }
    //fm.icelink.conference
    SetupConference(conference) {
        //conference.DtlsCertificate = this.DtlsCertificate;
        conference.setRelayUsername(this.RelayUsername);
        conference.setRelayPassword(this.RelayPassword);
        conference.setTimeout(this.ConferenceTimeout);
        conference.setDeadStreamTimeout(this.DeadStreamTimeout);
        if (this.OnConferenceLinkInit) {
            conference.addOnLinkInit(this.OnConferenceLinkInit);
        }
        if (this.OnConferenceLinkUp) {
            conference.addOnLinkUp(this.OnConferenceLinkUp);
        }
        if (this.OnConferenceLinkDown) {
            conference.addOnLinkDown(this.OnConferenceLinkDown);
        }
        if (this.OnConferenceLinkReceiveRTCP) {
            conference.addOnLinkReceiveRTCP(this.OnConferenceLinkReceiveRTCP);
        }
        if (this.OnConferenceLinkReceiveRTP) {
            conference.addOnLinkReceiveRTP(this.OnConferenceLinkReceiveRTP);
        }
        if (this.OnConferenceLinkReceiveSCTP) {
            conference.addOnLinkReceiveSCTP(this.OnConferenceLinkReceiveSCTP);
        }
        if (this.OnConferenceLinkSendRTCP) {
            conference.addOnLinkSendRTCP(this.OnConferenceLinkSendRTCP);
        }
        if (this.OnConferenceLinkSendRTP) {
            conference.addOnLinkSendRTP(this.OnConferenceLinkSendRTP);
        }
        //沒有LinkSendSCTP不要鬧了
        //if (OnConferenceLinkSendSCTP != null)
        //{
        //    conference.OnLinkSendSCTP += OnConferenceLinkSendSCTP;
        //}
        this._conference = conference;
    }
    SetupVideoStream(videoStream //fm.icelink.webrtc.videoStream
    ) {
        if (this.OnVideoStreamLinkInit) {
            videoStream.addOnLinkInit(this.OnVideoStreamLinkInit);
        }
        if (this.OnVideoStreamLinkUp) {
            videoStream.addOnLinkUp(this.OnVideoStreamLinkUp);
        }
        if (this.OnVideoStreamLinkDown) {
            videoStream.addOnLinkDown(this.OnVideoStreamLinkDown);
        }
        if (this.OnVideoStreamLinkReceiveRTCP) {
            videoStream.addOnLinkReceiveRTCP(this.OnVideoStreamLinkReceiveRTCP);
        }
        if (this.OnVideoStreamLinkReceiveRTP) {
            videoStream.addOnLinkReceiveRTP(this.OnVideoStreamLinkReceiveRTP);
        }
        this._videoStream = videoStream;
    }
    SetupAudioStream(audioStream //fm.icelink.webrtc.audioStream
    ) {
        if (this.OnAudioStreamLinkInit) {
            audioStream.addOnLinkInit(this.OnAudioStreamLinkInit);
        }
        if (this.OnAudioStreamLinkUp) {
            audioStream.addOnLinkUp(this.OnAudioStreamLinkUp);
        }
        if (this.OnAudioStreamLinkDown) {
            audioStream.addOnLinkDown(this.OnAudioStreamLinkDown);
        }
        if (this.OnAudioStreamLinkReceiveRTCP) {
            audioStream.addOnLinkReceiveRTCP(this.OnAudioStreamLinkReceiveRTCP);
        }
        if (this.OnAudioStreamLinkReceiveRTP) {
            audioStream.addOnLinkReceiveRTP(this.OnAudioStreamLinkReceiveRTP);
        }
        this._audioStream = audioStream;
    }
    Clear() {
        if (this._conference) {
            if (this.OnConferenceLinkInit)
                this._conference.removeOnLinkInit(this.OnConferenceLinkInit);
            if (this.OnConferenceLinkUp)
                this._conference.removeOnLinkUp(this.OnConferenceLinkUp);
            if (this.OnConferenceLinkDown)
                this._conference.removeOnLinkDown(this.OnConferenceLinkDown);
            if (this.OnConferenceLinkReceiveRTCP)
                this._conference.removeOnLinkReceiveRTCP(this.OnConferenceLinkReceiveRTCP);
            if (this.OnConferenceLinkReceiveRTP)
                this._conference.removeOnLinkReceiveRTP(this.OnConferenceLinkReceiveRTP);
            if (this.OnConferenceLinkReceiveSCTP)
                this._conference.removeOnLinkReceiveSCTP(this.OnConferenceLinkReceiveSCTP);
            if (this.OnConferenceLinkSendRTCP)
                this._conference.removeOnLinkSendRTCP(this.OnConferenceLinkSendRTCP);
            if (this.OnConferenceLinkSendRTP)
                this._conference.removeOnLinkSendRTP(this.OnConferenceLinkSendRTP);
            this._conference = null;
        }
        if (this._videoStream) {
            if (this.OnVideoStreamLinkInit)
                this._videoStream.removeOnLinkInit(this.OnVideoStreamLinkInit);
            if (this.OnVideoStreamLinkUp)
                this._videoStream.removeOnLinkUp(this.OnVideoStreamLinkUp);
            if (this.OnVideoStreamLinkDown)
                this._videoStream.removeOnLinkDown(this.OnVideoStreamLinkDown);
            if (this.OnVideoStreamLinkReceiveRTP)
                this._videoStream.removeOnLinkReceiveRTP(this.OnVideoStreamLinkReceiveRTP);
            if (this.OnVideoStreamLinkReceiveRTCP)
                this._videoStream.removeOnLinkReceiveRTCP(this.OnVideoStreamLinkReceiveRTCP);
            this._videoStream = null;
        }
        if (this._audioStream) {
            if (this.OnAudioStreamLinkInit)
                this._audioStream.removeOnLinkInit(this.OnAudioStreamLinkInit);
            if (this.OnAudioStreamLinkUp)
                this._audioStream.removeOnLinkUp(this.OnAudioStreamLinkUp);
            if (this.OnAudioStreamLinkDown)
                this._audioStream.removeOnLinkDown(this.OnAudioStreamLinkDown);
            if (this.OnAudioStreamLinkReceiveRTP)
                this._audioStream.removeOnLinkReceiveRTP(this.OnAudioStreamLinkReceiveRTP);
            if (this.OnAudioStreamLinkReceiveRTCP)
                this._audioStream.removeOnLinkReceiveRTCP(this.OnAudioStreamLinkReceiveRTCP);
            this._audioStream = null;
        }
        this._linkStatsDic.clear();
    }
    AddLink(linkId, attendee) {
        if (this._linkStatsDic.has(linkId))
            return;
        this._linkStatsDic.set(linkId, new LinkStatistics(attendee));
    }
    ReportLinkPacketPercentLost(linkId, percentLost) {
        if (!this._linkStatsDic.has(linkId))
            return;
        const linkStats = this._linkStatsDic.get(linkId);
        if (!linkStats)
            return;
        if (Math.abs(percentLost - linkStats.CurPercentLost) > 0.01 //只要變動率>1%就發Event
        //|| (linkStats.CurPercentLost > 0 && percentLost == 0) //處理一次跳回0的Case，但如果變動很大就
        ) {
            const curPercentLost = new Number(percentLost);
            //掉包率有變化發個Event
            if (this.ConferenceEventCallback) {
                this.ConferenceEventCallback(this.FromSessionTicket, Session_1.SessionInternalEvent.OneLinkWithAttendeePacketLossPercentChanged, linkStats.Attendee, curPercentLost);
            }
        }
        linkStats.CurPercentLost = percentLost;
    }
}
exports.ConferenceResource = ConferenceResource;
//# sourceMappingURL=ConferenceResource.js.map